module.exports = __webpack_public_path__ + "static/media/regulations.972db9ec.pdf";